<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useFunctionGetter, useStore } from 'dashboard/composables/store';
import WootReports from './components/WootReports.vue';
import CompanyBreakdownTables from './components/CompanyBreakdownTables.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const route = useRoute();
const store = useStore();
const companyId = computed(() => route.params.id);
const company = useFunctionGetter('companies/getCompanyById', companyId);

onMounted(() => store.dispatch('companies/get'));
</script>

<template>
  <div v-if="company?.id">
    <WootReports
      :key="company.id"
      type="company"
      getter-key="companies/getCompanies"
      action-key="companies/get"
      :selected-item="company"
      :download-button-label="$t('COMPANY_REPORTS.DOWNLOAD_COMPANY_REPORTS')"
      :report-title="company.name"
      has-back-button
    />
    <CompanyBreakdownTables :company-id="company.id" />
  </div>
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
